// @flow

// This type is necessary becuase by default flow infers values as `string`s
// instead of literal values which does not match with `Service` type.
type AncillaryServiceType = {|
  blueribbonBags: "blueribbon_bags",
  airHelp: "airhelp_plus",
  coverMore: "cover_more",
  paidCheckin: "paid_checkin",
  fastTrack: "fast_track",
|}

/**
 * Object that maps ancillary state name to node server response key
 */
const ANCILLARY_SERVICES: AncillaryServiceType = Object.freeze({
  blueribbonBags: "blueribbon_bags",
  airHelp: "airhelp_plus",
  coverMore: "cover_more",
  paidCheckin: "paid_checkin",
  fastTrack: "fast_track",
})

export type AncillaryService = $Keys<typeof ANCILLARY_SERVICES>

export const DEFAULT_ANCILLARIES: AncillaryService[] = Object.keys(ANCILLARY_SERVICES)

export default ANCILLARY_SERVICES
